import {
  AlertSpg,
  BlockText,
  GridContainer,
  GridItem,
  selectThunkRecordById,
  ViewSection,
} from "@duosoftbg/nacid-components";
import useAppSelector from "../../../../../../hooks/redux/base/useAppSelector";
import { useTranslation } from "react-i18next";
import * as React from "react";

const ResultReceiveViewSection = ({ record }) => {
  const { t } = useTranslation();

  const receiveResultData = useAppSelector((state) => {
    return state.AppData.receiveResult.data;
  });

  return (
    <ViewSection label={"t.resultReceive.way.default"}>
      {record.resultReceive?.id && (
        <GridContainer spacing={3} mt={0}>
          <BlockText
            propsGrid={{ md: 11 }}
            withGrid
            label={"t.resultReceive.way"}
            text={selectThunkRecordById(record.resultReceive?.id, receiveResultData)?.name}
          />
        </GridContainer>
      )}
      {!record.resultReceive?.id && (
        <GridContainer spacing={2} mt={0}>
          <GridItem sm={12} md={12} lg={12} paddingLeft={"10px"}>
            <AlertSpg severity={"info"}>{t("m.empty.receiveResult.way.default")}</AlertSpg>
          </GridItem>
        </GridContainer>
      )}
    </ViewSection>
  );
};
export default ResultReceiveViewSection;
